import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';

export default function PublicCompetitionsApi() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPublicCompetitions = async () => {
      try {
        const eventsRef = collection(db, 'events');
        const snapshot = await getDocs(eventsRef);

        // Egyesületi logó cache a gyors eléréshez
        const clubLogoCache = {};

        const activeEvents = [];

        for (const docSnap of snapshot.docs) {
          const comp = docSnap.data();

          // Szigorú szűrés: lezárt, rejtett vagy teszt [REJTETT] versenyek kizárása
          const isClosed = comp.status === 'Lezárt' || comp.status === 'completed';
          const isHidden = comp.isHidden === true;
          const isHiddenInName = comp.competitionName?.toLowerCase().includes('[rejtett]');

          if (!isClosed && !isHidden && !isHiddenInName) {
            let clubLogo = comp.organizingClubLogo || comp.authorImage || '';

            // Ha nincs eltárolva logó közvetlenül a versenyben, lekérjük a Clubs gyűjteményből
            if (!clubLogo && comp.organizerUid) {
              if (clubLogoCache[comp.organizerUid] !== undefined) {
                clubLogo = clubLogoCache[comp.organizerUid];
              } else {
                try {
                  const clubDoc = await getDoc(doc(db, 'Clubs', comp.organizerUid));
                  if (clubDoc.exists()) {
                    clubLogo = clubDoc.data().logoUrl || clubDoc.data().profileImageUrl || '';
                  } else {
                    const userDoc = await getDoc(doc(db, 'users', comp.organizerUid));
                    if (userDoc.exists()) {
                      clubLogo = userDoc.data().profileImageUrl || '';
                    }
                  }
                } catch (err) {
                  clubLogo = '';
                }
                clubLogoCache[comp.organizerUid] = clubLogo;
              }
            }

            activeEvents.push({
              id: docSnap.id,
              name: comp.competitionName || 'Verseny',
              type: comp.competitionType || '3D',
              date: comp.competitionDate || comp.startDate || '',
              endDate: comp.endDate || comp.competitionDate || comp.startDate || '',
              location: comp.location || '',
              gpsLatitude: comp.gpsLatitude || '',
              gpsLongitude: comp.gpsLongitude || '',
              organizingClub: comp.organizingClub || comp.organizer || '',
              organizingClubLogo: clubLogo,
              participantsCount: comp.participantsCount || 0,
              maxParticipants: comp.maxParticipants || 999,
              url: `https://archerynexus.com/verseny/${docSnap.id}`
            });
          }
        }

        setData(activeEvents);
      } catch (error) {
        console.error('API Error:', error);
        setData({ error: 'Failed to fetch competitions data' });
      } finally {
        setLoading(false);
      }
    };

    fetchPublicCompetitions();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '20px', fontFamily: 'monospace', color: '#666' }}>
        Loading public competitions API... 🏹
      </div>
    );
  }

  return (
    <pre style={{
      margin: 0,
      padding: '20px',
      backgroundColor: '#121212',
      color: '#00E676',
      fontFamily: 'monospace',
      fontSize: '13px',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-all',
      minHeight: '100vh'
    }}>
      {JSON.stringify(data, null, 2)}
    </pre>
  );
}
